import { Product } from '../../types/product'
import { CartItem } from '../../types/cart'
import { EventItem } from '../types'
import {
  getCartItemUnitPrice,
  getCatalogDiscountAmount,
  getDefaultVariant,
  getEffectivePrice,
  hasCatalogDiscount,
} from '../../utils/cartUtils'

export function productToEventItem(p: Product, quantity = 1): EventItem {
  const variant = getDefaultVariant(p.prices || [])
  const effectivePrice = variant ? getEffectivePrice(variant) : 0
  const discount =
    variant && hasCatalogDiscount(variant.discount)
      ? getCatalogDiscountAmount(variant)
      : undefined
  const variantLabel = variant?.weightLabel || variant?.weight || undefined
  return {
    id: p.id,
    name: p.name,
    category: p.categoryExternalName,
    variant: variantLabel,
    price: effectivePrice,
    quantity,
    discount,
  }
}

export function cartItemToEventItem(c: CartItem): EventItem {
  return {
    id: String(c.id),
    name: c.name,
    price: getCartItemUnitPrice(c),
    quantity: c.quantity,
  }
}
